import { render } from "./TenantsList.vue?vue&type=template&id=7a121109&scoped=true"
import script from "./TenantsList.vue?vue&type=script&lang=js"
export * from "./TenantsList.vue?vue&type=script&lang=js"

import "./TenantsList.vue?vue&type=style&index=0&id=7a121109&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a121109"]])

export default __exports__